import {
  USER_PREFERENCE_CLIENT,
  USER_PREFERENCE_PLATFORM
} from '@/shared/constants/user-preference.constants';
import type { CommunicationLanguage, UserPreferenceResponse } from '@/shared/models/user-preference.model';

export function resolveLanguageFromPreferences(
  data: UserPreferenceResponse[] | null | undefined,
  platform: string = USER_PREFERENCE_PLATFORM,
  client: string = USER_PREFERENCE_CLIENT,
  appDefault: CommunicationLanguage
): CommunicationLanguage {
  if (!data?.length) {
    return appDefault;
  }

  const match = data.find((p) => p.platform === platform && p.client === client);

  if (match?.language === 'en' || match?.language === 'ar') {
    return match.language;
  }

  return appDefault;
}
